import { render, staticRenderFns } from "./TableDashboardApprovals.vue?vue&type=template&id=0d061490&scoped=true&"
import script from "./TableDashboardApprovals.vue?vue&type=script&lang=js&"
export * from "./TableDashboardApprovals.vue?vue&type=script&lang=js&"
import style0 from "./TableDashboardApprovals.vue?vue&type=style&index=0&id=0d061490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d061490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d061490')) {
      api.createRecord('0d061490', component.options)
    } else {
      api.reload('0d061490', component.options)
    }
    module.hot.accept("./TableDashboardApprovals.vue?vue&type=template&id=0d061490&scoped=true&", function () {
      api.rerender('0d061490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/vistas/dashboard/TableDashboardApprovals.vue"
export default component.exports